import React from 'react';
import './StyleComponents/HomePassion.css';

const HomePassion = () => {
    return (
        <section className="MagicWrapper" id='magic'>

            <h1 className="MagicHeader">Your Magic ✨</h1>

            <div className="MagicGrid">

                {/* SUPER POWERS */}
                <div className="MagicCard">
                    <h2>Her Superpowers</h2>
                    <ul>
                        <li>
                            <b>Angel energy:</b> The essence of the universe. She gives courage
                            and unlimited strength to anything she want <i>warning: highly addictive.</i>
                        </li>
                        <li>
                            <b>Opens any door:</b> Nothing can be locked… especially parking doors.
                        </li>
                        <li>
                            <b>Vampire mode:</b> Be careful — she needs blood and she steals
                            your energy (in the best way).
                        </li>
                        <li>
                            <b>Tames demonic cats:</b> Even Luzerne somehow becomes an angel around her.
                        </li>
                        <li>
                            <b>Elite chef:</b> The best food you’ll ever taste.
                        </li>
                    </ul>
                </div>

                {/* QUOTES */}
                <div className="MagicCard">
                    <h2>Zara’s Best Quotes</h2>
                    <ul>
                        <li>“We are protected and blessed.”</li>
                        <li>“Everything happens for the best.”</li>
                        <li>“Ouh… will there be fish to eat at the Russian restaurant? Miam 😋”</li>
                        <li>“Oh look, a Chinese baby :o”</li>
                        <li>“Whiskering me away.”</li>
                        <li>“That’s up my street.”</li>
                        <li>“I lie in.”</li>
                        <li>“A bit of a bug.”</li>
                        <li>“Chummying.”</li>
                    </ul>
                </div>

            </div>

        </section>
    );
};

export default HomePassion;
